import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { recordSignupRedirect } from '@/lib/signupOrigin';

function isPageLocation(value: unknown): value is { pathname: string; search: string } {
  if (typeof value !== 'object' || value === null) return false;
  const { pathname, search } = value as { pathname?: unknown; search?: unknown };
  return typeof pathname === 'string' && typeof search === 'string';
}

export function useCaptureSignupRedirect(): void {
  const { state } = useLocation();

  useEffect(() => {
    const from: unknown = (state as { from?: unknown } | null)?.from;
    if (isPageLocation(from)) recordSignupRedirect(from);
  }, [state]);
}
